// @flow
import type { ApplicationState } from "../../state/types";

import React, { PureComponent } from "react";

import { withTranslate } from "../translation";

import "./register.css";

type Props = {
  t: Function,
};

class RegisterSuccess extends PureComponent<Props> {
  render() {
    const { t } = this.props;
    return (
      <div className="h-screen">
        <div className="pt-20 flex justify-center ">
          <div className="bg-teal-500 p-5 rounded-lg">
            <h1 className="text-xl font-bolder text-white">
              {t(`RegisterForm.thanks`)}
            </h1>
          </div>
        </div>
        <div>

        </div>
      </div>
    );
  }
}

export default withTranslate(RegisterSuccess);
